module.exports = __webpack_public_path__ + "8e46c3835a7d11de96b874e7a920e500.jpeg";


//////////////////
// WEBPACK FOOTER
// ./components/home/landing/alt/send.jpeg
// module id = 700
// module chunks = 0